import { render, staticRenderFns } from "./CustomFieldList.vue?vue&type=template&id=d4f5bb04&scoped=true&"
import script from "./CustomFieldList.vue?vue&type=script&lang=js&"
export * from "./CustomFieldList.vue?vue&type=script&lang=js&"
import style0 from "./CustomFieldList.vue?vue&type=style&index=0&id=d4f5bb04&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4f5bb04",
  null
  
)

export default component.exports